import React from "react";
import Lottie from "lottie-react";
import platform from "@/config/platform";
import LoadingData from "./data.json";
import styles from "./styles.module.scss";
const Loading = ({ className = "" }) => {
  return (
    <div className={`${styles.loading} ${className}`}>
      {platform.name === "BTCC" ? (
        <div className={styles.lottie}>
          <Lottie animationData={LoadingData} loop={true} />
        </div>
      ) : (
        <>
          <div className={styles.preloading}>
            <img width="64" src={platform.logo} alt={platform.name} />
            <div className="line-scale-pulse-out">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default Loading;
